module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/cloud-46525b91c10e8a745512d8aa2ed95706.png";